export default {
  FACEBOOK: 'facebook',
  LINKEDIN: 'linkedin',
  TWITTER: 'twitter',
  EMAIL: 'email',
  MANUAL_INVITE: 'manual-invite',
  COPY_INVITE: 'copy-invite',
  WEBSHARE_API: 'webshare-api',
};
